import {
    Card,
    CardContent,
    CardHeader,
    FormControl,
    FormControlLabel,
    FormHelperText,
    Grid2,
    IconButton,
    Stack,
    Switch,
} from "@mui/material";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialInput from "../../../components/MaterialInput";
import MaterialBox from "../../../components/MaterialBox";
import { ArrowBack } from "@mui/icons-material";
import { useNavigate, useSearchParams } from "react-router-dom";
import MaterialButton from "../../../components/MaterialButton";
import DashboardFooter from "../../../layoutcontainers/DashboardLayout/components/Footer";
import { fetchData, fetchDataById, postData, putData } from "../../../services";
import { useEffect, useReducer, useState } from "react";
import { handelChange } from "../../../reducers/formReducer";
import MaterialSelect from "../../../components/MasterSelect";
import { useSnackbar } from "../../../context/popup";
import { useLoading } from "../../../components/Loading";

const initialState = {
    generalInsurer: {},
    generalInsurerErr: "unchecked",
    parentCategory: {},
    parentCategoryErr: "unchecked",
    categoryName: "",
    categoryNameErr: "unchecked",
    code: "",
    codeErr: "unchecked",
    description: "",
    descriptionErr: "unchecked",
    active: true,
};

const InsurerCategoryForm = () => {
    const { showSnackbar } = useSnackbar();
    const { setCircleLoading } = useLoading();
    const [state, dispatch] = useReducer(handelChange, initialState);
    const [dropdown, setDropdown] = useState({
        insurer: [],
        parentCategory: [],
    });

    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const Id = searchParams.get("id");
    const pageType = searchParams.get("pageType");

    const pageMode =
        pageType === "view" ? "view" : pageType === "edit" ? "edit" : "add";

    useEffect(() => {
        const fetchInsurerList = async () => {
            setCircleLoading(true);
            try {
                const response = await fetchData(
                    `/reference/general/insurer-master?dropdown=true&isActive=true`
                );

                setDropdown((prev) => ({
                    ...prev,
                    insurer: response?.data?.items?.map((item) => ({
                        value: item?.id,
                        label: item?.companyName,
                    })),
                }));
            } catch (error) {
                console.error("Error Fetching Insurers:", error);
            } finally {
                setCircleLoading(false);
            }
        };

        const fetchParentCategoryList = async () => {
            setCircleLoading(true);
            try {
                const response = await fetchData(
                    `/reference/insurer/key-value-category?dropdown=true&isActive=true`
                );

                setDropdown((prev) => ({
                    ...prev,
                    parentCategory: response?.data?.items?.map((item) => ({
                        value: item?.id,
                        label: item?.categoryName,
                    })),
                }));
            } catch (error) {
                console.error("Error Fetching Parent Categories:", error);
            } finally {
                setCircleLoading(false);
            }
        };

        fetchInsurerList();
        fetchParentCategoryList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const fetchCategoryById = async () => {
            setCircleLoading(true);
            try {
                const data = await fetchDataById(`/reference/insurer/key-value-category/${Id}`);
                const responseData = data?.data;

                if (data?.success) {
                    dispatch({
                        type: "bulkUpdate",
                        payload: {
                            generalInsurer: {
                                value: responseData?.gInsurerId,
                                label: responseData?.gInsurerName,
                            },
                            parentCategory: {
                                value: responseData?.parentCategoryId,
                                label: responseData?.parentCategoryName,
                            },
                            categoryName: responseData?.categoryName,
                            code: responseData?.code,
                            description: responseData?.description,
                            active: responseData?.isActive,
                        },
                    });
                }
            } catch (error) {
                console.error("Error fetching data by ID:", error);
            } finally {
                setCircleLoading(false);
            }
        };
        if (Id) {
            fetchCategoryById();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [Id]);

    const handelSubmit = async () => {
        const payload = {
            gInsurerId: state?.generalInsurer?.value,
            parentCategoryId: state?.parentCategory?.value,
            categoryName: state?.categoryName,
            code: state?.code,
            description: state?.description,
            isActive: state?.active,
        };
        if (pageMode === "edit") {
            try {
                setCircleLoading(true);
                const response = await putData(
                    `/reference/insurer/key-value-category/${Id}`,
                    payload
                );
                const responseMessage = response?.message;
                if (response?.success) {
                    showSnackbar(responseMessage, "success");
                    navigate("/insurer-master/insurer-category");
                } else {
                    showSnackbar(responseMessage, "error");
                }
            } catch (error) {
                showSnackbar(error?.response?.data?.message, "error");
            } finally {
                setCircleLoading(false);
            }
        } else {
            try {
                setCircleLoading(true);
                const response = await postData("/reference/insurer/key-value-category", payload);
                const responseMessage = response?.message;
                if (response?.success) {
                    showSnackbar(responseMessage, "success");
                    navigate("/insurer-master/insurer-category");
                } else {
                    showSnackbar(responseMessage, "error");
                }
            } catch (error) {
                showSnackbar(error?.response?.data?.message, "error");
            } finally {
                setCircleLoading(false);
            }
        }
    };

    const checkAllFields = () => {
        let allowSubmit = false;

        if (
            state.categoryNameErr === "success" &&
            state.codeErr === "success"
        ) {
            allowSubmit = false;
        } else {
            allowSubmit = true;
        }

        return allowSubmit;
    };
    return (
        <>
            <DashboardLayout>
                <Card sx={{ minHeight: 500 }}>
                    <CardHeader
                        title={
                            <Stack
                                direction="row"
                                justifyContent="space-between"
                                alignItems="center"
                                spacing={2}
                            >
                                <Stack direction="row" alignItems="center" spacing={1}>
                                    <IconButton
                                        onClick={() =>
                                            navigate("/insurer-master/insurer-category")
                                        }
                                    >
                                        <ArrowBack />
                                    </IconButton>
                                    <Stack direction="column" spacing={0}>
                                        <MaterialTypography variant="h5" fontWeight="medium">
                                            Insurer Category Details
                                        </MaterialTypography>
                                        <MaterialTypography variant="caption" color="text">
                                            Enter New Insurer Category Details.
                                        </MaterialTypography>
                                    </Stack>
                                </Stack>
                            </Stack>
                        }
                    />

                    <CardContent>
                        <Grid2 container spacing={2}>
                            <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                                <MaterialBox>
                                    <MaterialTypography
                                        component="label"
                                        variant="caption"
                                        fontWeight="bold"
                                    >
                                        General Insurer
                                    </MaterialTypography>
                                </MaterialBox>
                                <MaterialSelect
                                    name="generalInsurer"
                                    options={dropdown?.insurer}
                                    value={state?.generalInsurer}
                                    onChange={(e) =>
                                        dispatch({
                                            type: "Select",
                                            value: e,
                                            name: "generalInsurer",
                                        })
                                    }
                                    success={state?.generalInsurerErr === "success"}
                                    isDisabled={pageMode === "view"}
                                    isClearable
                                />
                            </Grid2>
                            <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                                <MaterialBox>
                                    <MaterialTypography
                                        component="label"
                                        variant="caption"
                                        fontWeight="bold"
                                    >
                                        Parent Category
                                    </MaterialTypography>
                                </MaterialBox>
                                <MaterialSelect
                                    options={dropdown?.parentCategory}
                                    value={state?.parentCategory}
                                    onChange={(e) =>
                                        dispatch({
                                            type: "Select",
                                            value: e,
                                            name: "parentCategory",
                                        })
                                    }
                                    success={state?.parentCategoryErr === "success"}
                                    error={state.parentCategoryErr === "error"}
                                    isDisabled={pageMode === "view"}
                                />
                            </Grid2>

                            <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                                <MaterialBox>
                                    <MaterialTypography
                                        component="label"
                                        variant="caption"
                                        fontWeight="bold"
                                    >
                                        Category Name <span className="span">*</span>
                                    </MaterialTypography>
                                </MaterialBox>
                                <MaterialInput
                                    name="categoryName"
                                    value={state?.categoryName}
                                    onChange={(e) =>
                                        dispatch({
                                            value: e?.target?.value,
                                            name: "categoryName",
                                            type: "input",
                                            regex: "^([\\s\\S]{1,100})$",
                                        })
                                    }
                                    success={state?.categoryNameErr === "success"}
                                    error={state.categoryNameErr === "error"}
                                    disabled={pageMode === "view"}
                                />
                                {state.categoryNameErr === "error" && (
                                    <FormControl error>
                                        <FormHelperText>
                                            Category Name should be a minimum 1 character & maximum 100
                                            characters long.
                                        </FormHelperText>
                                    </FormControl>
                                )}
                            </Grid2>

                            <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                                <MaterialBox>
                                    <MaterialTypography
                                        component="label"
                                        variant="caption"
                                        fontWeight="bold"
                                    >
                                        Code <span className="span">*</span>
                                    </MaterialTypography>
                                </MaterialBox>
                                <MaterialInput
                                    name="code"
                                    value={state?.code}
                                    onChange={(e) =>
                                        dispatch({
                                            value: e?.target?.value,
                                            name: "code",
                                            type: "input",
                                            regex: "^([\\s\\S]{1,20})$",
                                        })
                                    }
                                    success={state?.codeErr === "success"}
                                    error={state.codeErr === "error"}
                                    disabled={pageMode === "view"}
                                />
                                {state.codeErr === "error" && (
                                    <FormControl error>
                                        <FormHelperText>
                                            Code should be a minimum 1 character & maximum 20
                                            characters long.
                                        </FormHelperText>
                                    </FormControl>
                                )}
                            </Grid2>

                            <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                                <MaterialBox>
                                    <MaterialTypography
                                        component="label"
                                        variant="caption"
                                        fontWeight="bold"
                                    >
                                        Description
                                    </MaterialTypography>
                                </MaterialBox>
                                <MaterialInput
                                    name="description"
                                    value={state?.description}
                                    onChange={(e) =>
                                        dispatch({
                                            value: e?.target?.value,
                                            name: "description",
                                            type: "input",
                                            regex: "^([\\s\\S]{0,500})$",
                                        })
                                    }
                                    success={state?.descriptionErr === "success"}
                                    error={state.descriptionErr === "error"}
                                    disabled={pageMode === "view"}
                                    multiline
                                    rows={3}
                                />
                                {state.descriptionErr === "error" && (
                                    <FormControl error>
                                        <FormHelperText>
                                            Description should be maximum 500 characters long.
                                        </FormHelperText>
                                    </FormControl>
                                )}
                            </Grid2>

                            <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                                <MaterialBox>
                                    <MaterialTypography
                                        component="label"
                                        variant="caption"
                                        fontWeight="bold"
                                    >
                                        Active
                                    </MaterialTypography>
                                </MaterialBox>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={state?.active}
                                            onChange={() =>
                                                dispatch({
                                                    type: "switch",
                                                    name: "active",
                                                    value: !state?.active,
                                                })
                                            }
                                            color="primary"
                                            disabled={pageMode === "view"}
                                        />
                                    }
                                    label={
                                        <MaterialTypography variant="caption" fontWeight="bold">
                                            {state?.active ? "Active" : "Inactive"}
                                        </MaterialTypography>
                                    }
                                />
                            </Grid2>
                        </Grid2>
                    </CardContent>
                    <MaterialBox
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                    >
                        {pageMode !== "view" && (
                            <>
                                <MaterialButton
                                    sx={{ m: 2 }}
                                    variant="outlined"
                                    color="dark"
                                    onClick={() =>
                                        navigate("/insurer-master/insurer-category")
                                    }
                                >
                                    Cancel
                                </MaterialButton>
                                <MaterialButton
                                    sx={{ m: 2 }}
                                    variant="gradient"
                                    color="dark"
                                    disabled={checkAllFields()}
                                    onClick={handelSubmit}
                                >
                                    {pageMode === "add" ? "Submit" : "Update"}
                                </MaterialButton>
                            </>
                        )}
                    </MaterialBox>
                </Card>
            </DashboardLayout>
            <DashboardFooter />
        </>
    );
};

export default InsurerCategoryForm;